import { render, staticRenderFns } from "./BouncingVowels.vue?vue&type=template&id=a25f7906&scoped=true&"
import script from "./BouncingVowels.vue?vue&type=script&lang=js&"
export * from "./BouncingVowels.vue?vue&type=script&lang=js&"
import style0 from "./BouncingVowels.vue?vue&type=style&index=0&id=a25f7906&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25f7906",
  null
  
)

export default component.exports